import React from 'react';
import {LinearProgress} from 'material-ui/Progress';

function LinearQuery() {
    return (
        <div>
            <LinearProgress mode="query" />
            <br />
            <LinearProgress color="secondary" mode="query"/>
        </div>
    );
}

export default LinearQuery;


// WEBPACK FOOTER //
// ./app/routes/components/routes/progressbar/linear/query/LinearQuery.js